export default __webpack_public_path__ + "static/media/image_soulless.0049ac81.png";